module.exports = __webpack_public_path__ + "static/about_background_1-dfeb6cd1a0800b5a69b5940799578041.jpg";